<nav class="header__desktop-menu" aria-label="Main navigation">
  <ul class="header__menu-list">
    @for (item of menu(); track item.title) {
      <li
        class="header__menu-item"
        [class.header__menu-item--has-submenu]="item.children && item.children.length">
        @if (!item.children) {
          <a [routerLink]="item.link" class="header__menu-link">
            {{ item.title | translate }}
          </a>
        }
        @if (item.children && item.children.length) {
          <div class="header__dropdown">
            <button mat-button class="header__dropdown-trigger" aria-haspopup="true" [attr.aria-expanded]="false">
              {{ item.title | translate }}
            </button>
            <div class="header__dropdown-content">
              @for (child of item.children; track child.link) {
                <a class="header__dropdown-item" [href]="child.link">
                  {{ child.title | translate }}
                </a>
              }
            </div>
          </div>
        }
      </li>
    }
  </ul>
</nav>
